/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator/services';
import { apiConfig } from '@/config/apiConfig';
import { GET_OCCUPATION_LIST } from '../../api/graphql';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export interface IGetOccupationListMethods extends IPluginMethodMap {
  getOccupationList(): Promise<any>;
}

export class GetOccupationListService implements IAgentPlugin {
  readonly methods: IGetOccupationListMethods;

  constructor() {
    this.methods = {
      getOccupationList: this.getOccupationList.bind(this),
    };
  }

  async getOccupationList() {
    const storageService = StorageModule.getInstance();

    const localToken = storageService.get('myProfile', 'local');
    const sessionToken = storageService.get('myProfile', 'session');
    const vuid = localToken?.vuid ?? sessionToken?.vuid;
    console.log('po->', vuid);
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_OCCUPATION_LIST, {});
        if (res?.data?.getOccupationList?.tree?.length > 0) {
          console.log(`table data222`, res);

          return {
            data: this.format(res?.data?.getOccupationList?.tree[0]?.children),
          };
        } else {
          return {
            data: [],
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }
  private format(data: any[]): any[] {
    return data?.map((item) => {
      if (item?.children && item?.children?.length > 0) {
        return {
          value: `_${item?.id}:${item?.name}`,
          label: item?.name,
          children: this.format(item?.children),
        };
      }
      return {
        value: `${item?.id}:${item?.name}`,
        label: item?.name,
      };
    });
  }
}
